import React, { useState, useEffect, useMemo } from "react";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import SearchBar from "../../../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";
import { FaSpinner } from "react-icons/fa";

const Dynamic_PR_table = ({
  data,
  selectedResource,
  selectAllChecked,
  columns,
  defaultColumns,
  isRequiredStatus,
  isApiStatus,
  handleBtn,
  // itemsPerPage,
  searchTerm,
  setSearchTerm,
  handleIconClick,
  handleModalColumn,
  icons,
  isActionRequired,
  isCheckBoxRequired,
  showIcon1,
  showIcon2,
  showIcon3,
  showIcon4,
  showIcon5,
  handleIcon1,
  ReadOnlyValues,
  handleIcon2,
  handleIcon3,
  handleIcon4,
  handleIcon5,
  handleCheckboxChange,
  handleSelectAllChange,

}) => {
  const [visibleColumns, setVisibleColumns] = useState(defaultColumns);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

    const [itemsPerPage, setItemsPerPage] = useState(10);

  // const [selectAllChecked, setSelectAllChecked] = useState(false);
  // const [selectedItems, setSelectedItems] = useState({});

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);
  useEffect(() => {
    setCurrentPage(1);  // Reset page when data or columns change
    setVisibleColumns(defaultColumns);  // Reset visible columns to defaults
  }, [data, columns, defaultColumns]);
  


  useEffect(() => {
    setCurrentPage(1);  // Reset page when data or columns change
    setVisibleColumns(defaultColumns);  // Reset visible columns to defaults
  }, [data, columns, defaultColumns]);

  const toggleColumn = (columnName) => {
    setVisibleColumns((prevColumns) => ({
      ...prevColumns,
      [columnName]: !prevColumns[columnName],
    }));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const navigate = useNavigate();

  const sortedData = useMemo(() => {
    let sortableItems = [...data];
    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [data, sortConfig]);

  const filteredData = sortedData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);

  const handleSort = (columnName) => {
    setSortConfig((prevSortConfig) => {
      let direction = "ascending";
      if (
        prevSortConfig.key === columnName &&
        prevSortConfig.direction === "ascending"
      ) {
        direction = "descending";
      }
      return { key: columnName, direction };
    });
  };
  // const formatDate = (date) => {
  //   if (!date) return ""; // Handle null or undefined dates

  //   // Check if the date is already in DD-MM-YYYY format
  //   const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
  //   if (dateRegex.test(date)) {
  //     return date;
  //   }

  //   return moment(date).format("DD-MMM-YYYY");
  // };


  //new updateed code for date fromat 
  const formatDate = (date) => {
    if (!date) return ""; // check date is null or undefined

    // Use moment
    const parsedDate = moment(
      date,
      [
        moment.ISO_8601, // Handles ISO date formats
        "DD-MM-YYYY", // Specific format check
        "MM/DD/YYYY", // U.S. format
        "YYYY-MM-DD", // Standard format
      ],
      true
    );

    // Return formatted date if valid, otherwise an empty string
    return parsedDate.isValid() ? parsedDate.format("DD-MMM-YYYY") : "";
  };
  const ExcelName = useSelector(
    ({ layoutReducer }) => layoutReducer?.filterSlice?.navbarHeading
  );


  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];
  
    const [dropDownValue, setDropdownValue] = useState({});
    const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);
  
    // Calculate total pages based on the current `selectedRecordsPerPage`
    // const totalPages = Math.ceil(filteredData.length / selectedRecordsPerPage);
  
    // Data to display for the current page
    const currentPageData = filteredData.slice(
      (currentPage - 1) * selectedRecordsPerPage,
      currentPage * selectedRecordsPerPage
    );
    const handleRecordsPerPage = (e) => {
      const newRecordsPerPage = Number(e.target.value);
  
      // Calculate the new starting record index based on the current page
      const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
      const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;
  
      // Update state 
      setSelectedRecordsPerPage(newRecordsPerPage);
      setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
      setItemsPerPage(newRecordsPerPage);
    };

  return (
    <div>
     <div className="d-flex justify-content-between" style={{ marginBottom:'-8px' }}>
             <div className="d-flex">
               <div className="me-1">
                 <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
               </div>
          
                 
               <div style={{
                 display: 'flex',
                 gap: '16px',
                 marginLeft: '8px'
               }}>
                 {ReadOnlyValues?.map((stat, index) => (
                   <div
                     key={index}
                     style={{
                       backgroundColor: '#f8f9fa',
                       padding: '4px 8px',
                       borderRadius: '4px',
                       height: "35px",
                       border: '1px solid #dee2e6'
                     }}
                   >
                     <span style={{ fontWeight: '600' }}>{stat.label}: </span>
                     <span>
                       {typeof stat.value === 'number' && stat.label.toLowerCase().includes('amount')
                         ? stat.value.toLocaleString('en-IN', {
                           style: 'currency',
                           currency: 'INR',
                           minimumFractionDigits: 2
                         })
                         : stat.value}
                     </span>
                   </div>
                 ))}
               </div>
             </div>
     
             <div className="d-flex justify-content-end">
               <OverlayTrigger
                 placement="top"
                 overlay={<Tooltip id="tooltip-top">Export to Excel</Tooltip>}
               >
                 <div className="me-1">
                   {/* <ExportToExcel
                     data={filteredData}
                     filename={`${ExcelName}.csv`}
                   /> */}
                   <ExportToExcel
                     data={currentData.map((item) => {
                       const visibleItem = {};
                       Object.keys(columns)
                         .filter((columnName) => visibleColumns[columnName])
                         .forEach((columnName) => {
                           const isDateColumn =
                             columns[columnName].text
     
                           visibleItem[columns[columnName].text] = isDateColumn
                             ? item[columnName]
                             : item[columnName];
                         });
                       return visibleItem;
                     })}
                     filename={`${ExcelName}.csv`}
                   />
                 </div>
               </OverlayTrigger>
               <OverlayTrigger
                 placement="top"
                 overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
               >
                 <div className="btn-group me-2">
                   <button
                     type="button"
                     className="dropdown-toggle skill-button"
                     data-bs-toggle="dropdown"
                     aria-expanded="false"
                     id="excel-btn"
                   >
                     <i className="bi bi-list"></i>
                   </button>
                   <ul className="dropdown-menu p-2">
                     <div className="row">
                       <Form.Group style={{ maxHeight: '350px', overflowY: 'auto', width: '250px' }}>
                         {Object.keys(columns).map((columnName) => (
                           <Form.Check
                             key={columnName}
                             type="checkbox"
                             id={`checkbox-${columnName}`}
                             label={columns[columnName].text}
                             checked={visibleColumns[columnName] || false}
                             onChange={() => toggleColumn(columnName)}
                           />
                         ))}
                       </Form.Group>
                     </div>
                   </ul>
                 </div>
     
               </OverlayTrigger>
               
             </div>
           </div>

      <div className="box-body table-responsive container-fluid p-0">
        <Table striped bordered hover>
          <thead id="thcolor" className="text-center">
            <tr>
              {isCheckBoxRequired && (
                <th>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selectAllChecked}
                    onChange={(e) => handleSelectAllChange(e)}
                  />
                </th>
              )}
              {Object.keys(columns).map(
                (columnName) =>
                  visibleColumns[columnName] && (
                    <th
                      style={{ whiteSpace: "nowrap" }}
                      key={columnName}
                      onClick={() => handleSort(columnName)}
                    >
                      {columns[columnName].text}
                      <span className="ms-2">
                        {sortConfig.key === columnName ? (
                          sortConfig.direction === "ascending" ? (
                            <i className="bi bi-chevron-up"></i>
                          ) : (
                            <i className="bi bi-chevron-down"></i>
                          )
                        ) : (
                          <i className="bi bi-chevron-down"></i>
                        )}
                      </span>
                    </th>
                  )
              )}
              {isActionRequired && <th>Action</th>}
            </tr>
          </thead>
         {isRequiredStatus ? (
              isApiStatus === 200 && currentData?.length != 0 ? ( <tbody>
            {currentData.map((item, index) => (
              <tr key={index}>
                {isCheckBoxRequired && (
                  <td className="text-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={
                        item.Ifexists === "1"
                          ? true
                          : item.EmployeeID
                            ? selectedResource.find((o) => o.EmployeeID === item.EmployeeID)
                              ? true
                              : false
                            : selectedResource.find((o) => o.ID === item.ID)
                              ? true
                              : false
                      }
                      disabled={item.Ifexists === "1"}  // Disable if item.ifExists is 1
                      onChange={(e) =>
                        handleCheckboxChange(e, item.ID ? item.ID : item.EmployeeID, item)
                      }
                    />
                  </td>
                )}

                {Object.keys(columns).map((columnName) => {
                  const isDateColumn = /date/i.test(columns[columnName].text);

                  const columnAlignment = columns[columnName].align || "left";
                  const columnWidth = columns[columnName].width;

                  const isButtonColumn = columns[columnName].type === "button";
                  const isModalColumn = columns[columnName].type === "Modal";
                  const isButtonName = columns[columnName].text;
                  const hasIcon = columns[columnName].icon;

                  return (
                    visibleColumns[columnName] &&
                    (item[columnName] !== null &&
                      item[columnName] !== undefined ? (
                      <OverlayTrigger
                        key={columnName}
                        placement="right"
                        overlay={
                          <Tooltip id={`tooltip-${columnName}`}>
                            {item[columnName]}
                          </Tooltip>
                        }
                      >
                        <td
                          className={`text-${columnAlignment} text-truncate`}
                          style={{
                            maxWidth: columnWidth || "100px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {isButtonColumn ? (
                            <button
                              className={`text-${columnAlignment} custom-btn`}
                              onClick={() => handleBtn(columnName, item)}
                            >
                              {isButtonName}
                            </button>
                          ) : hasIcon ? (
                            <div
                              className="d-flex align-items-center justify-content-center text-center"
                              onClick={() => handleIconClick(columnName, item)}
                            >
                              <span className="me-2">
                                {icons[columns[columnName].icon]}
                              </span>
                              {item[columnName]}
                            </div>
                          ) : isDateColumn ? (
                            formatDate(item[columnName])
                          ) : (
                            item[columnName]
                          )}
                        </td>
                      </OverlayTrigger>
                    ) : (
                      <td
                        key={columnName}
                        className={`text-${columnAlignment} text-truncate`}
                        style={{
                          maxWidth: columnWidth || "60px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {isButtonColumn ? (
                          <button
                            className={`text-${columnAlignment} custom-btn`}
                            onClick={() => handleBtn(columnName, item)}
                          >
                            {isButtonName}
                          </button>
                        ) : hasIcon ? (
                          // <OverlayTrigger
                          //   placement="bottom"
                          //   overlay={
                          //     <Tooltip id="tooltip-bottom">
                          //       {item[columns[columnName].iconText] || "Edit"}
                          //     </Tooltip>
                          //   }
                          // >
                          <div
                            className="d-flex align-items-center justify-content-center text-center"
                            onClick={() => handleIconClick(columnName, item)}
                          >
                            <span className="me-2">
                              {icons[columns[columnName].icon]}
                            </span>
                            {item[columnName]}
                          </div>
                          // </OverlayTrigger>
                        ) : isDateColumn ? (
                          formatDate(item[columnName])
                        ) : isModalColumn ? (
                          <a onClick={() => handleModalColumn(columnName, item)}> {item[columnName]}</a>
                        ) : (
                          item[columnName]
                        )}
                      </td>
                    ))
                  );
                })}
                {isActionRequired && (
                  <td>
                    <div className="d-flex justify-content-center text-center">
                      {showIcon1 && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="tooltip-bottom">
                              {icons.Icon1Text || "Edit"}
                            </Tooltip>
                          }
                        >
                          <div
                            className="me-2"
                            onClick={() => handleIcon1(item)}
                          >
                            {icons.Icon1}
                          </div>
                        </OverlayTrigger>
                      )}
                      {showIcon2 && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="tooltip-bottom">
                              {icons.Icon2Text || "Edit"}
                            </Tooltip>
                          }
                        >
                          <div
                            className="me-2"
                            onClick={() => handleIcon2(item)}
                          >
                            {icons.Icon2}
                          </div>
                        </OverlayTrigger>
                      )}
                      {showIcon3 && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="tooltip-bottom">
                              {icons.Icon3Text}
                            </Tooltip>
                          }
                        >
                          <div
                            className="me-2"
                            onClick={() => handleIcon3(item)}
                          >
                            {icons.Icon3}
                          </div>
                        </OverlayTrigger>
                      )}
                      {showIcon4 && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="tooltip-bottom">
                              {icons.Icon4Text || "Add"}
                            </Tooltip>
                          }
                        >
                          <div
                            className="me-2"
                            onClick={() => handleIcon4(item)}
                          >
                            {icons.Icon4}
                          </div>
                        </OverlayTrigger>
                      )}
                      {showIcon5 && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="tooltip-bottom">
                              {icons.Icon5Text || "Add"}
                            </Tooltip>
                          }
                        >
                          <div
                            className="me-2"
                            onClick={() => handleIcon5(item)}
                          >
                            {icons.Icon5}
                          </div>
                        </OverlayTrigger>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody> ) : isApiStatus === 200 && currentData?.length === 0 ? (
                          <tbody>
                            <tr>
                              <td
                                colSpan={
                                  Object.keys(columns).length +
                                  (isCheckBoxRequired ? 1 : 0) +
                                  (isActionRequired ? 1 : 0)
                                }
                                className="text-center"
                              >
                                <p>No Data Found</p>
                              </td>
                            </tr>
                          </tbody>
                        ) : isApiStatus === undefined && currentData?.length === 0 ? (
                          <tbody>
                            <tr>
                              <td
                                colSpan={
                                  Object.keys(columns).length +
                                  (isCheckBoxRequired ? 1 : 0) +
                                  (isActionRequired ? 1 : 0) 
                                }
                                className="text-center"
                              >
                                <div>
                                  <p>
                                    <FaSpinner class="spinner" />
                                    <br />
                                    Loading
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        ) : isApiStatus === undefined ? (
                          <tbody>
                            <tr>
                              <td
                                colSpan={
                                  Object.keys(columns).length +
                                  (isCheckBoxRequired ? 1 : 0) +
                                  (isActionRequired ? 1 : 0) 
                                }
                                className="text-center"
                              >
                                <div>
                                  <p>
                                    <FaSpinner class="spinner" />
                                    <br />
                                    Loading
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        ): (
                                      <tbody>
                                        <tr>
                                          <td
                                            colSpan={
                                              Object.keys(columns).length +
                                              (isCheckBoxRequired ? 1 : 0) +
                                              (isActionRequired ? 1 : 0) 
                                            }
                                            className="text-center"
                                          >
                                            <div>
                                              <p>
                                                <FaSpinner class="spinner" />
                                                <br />
                                                Loading
                                              </p>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    )):null}
        </Table>

         <div className="d-flex justify-content-between mb-3">
          <div>
            <span className="d-flex">
              Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
              {Math.min(
                currentPage * selectedRecordsPerPage,
                filteredData.length
              )}{" "}
              of {filteredData.length} <span className="ms-1">results</span>
              <select
                value={selectedRecordsPerPage}
                onChange={handleRecordsPerPage}
                className="mx-2 form-select-sm"
              >
                {recordsPerPageOption.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </span>
          </div>
          <div>
            <Pagination
              itemsPerPage={selectedRecordsPerPage}
              totalItems={filteredData.length}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dynamic_PR_table;
